import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { displayErrors } from '../../../../../common/utils/constants';
import { bankFeedsErrorQuery } from '../../BankingLanding/modules/BankingLandingActions';
import { useGraphQuery } from 'common/utils/graphql_utils';
import { useEffect } from '@storybook/addons';

const querystring = require('querystring');

const BankFeedsThanks = ({ location }: any) => {
  // Future-proofing. Newer versions of react-router don't parse the query string for us. https://github.com/ReactTraining/react-router/issues/4410
  let responseQuery = location.search;
  if (responseQuery.substring(0, 1) === '?') {
    responseQuery = responseQuery.substring(1);
  }

  const bankFeedsResponse = querystring.parse(responseQuery);

  const [state, setState] = useState({
    success:
      bankFeedsResponse.status &&
      bankFeedsResponse.status.toUpperCase() === 'COMPLETE',
    errorText: '',
  });

  useGraphQuery(
    [
      'bankFeedsErrorWebhook',
      {
        error: JSON.stringify(bankFeedsResponse),
      },
    ],
    bankFeedsErrorQuery,
    {
      enabled: !state.success,
      onError: (data: any) => {
        console.log(data.error);
      },
      onSuccess: () => {
        setState({
          ...state,
          errorText: bankFeedsResponse.errorText
            ? bankFeedsResponse.errorText
            : displayErrors[bankFeedsResponse.status],
        });
      },
    },
  );

  return (
    <div>
      <h2 className='text-center'>
        {state.success ? 'Bank Statements Connected' : 'Error'}
      </h2>
      <p className='text-center'>
        {state.success
          ? 'Thanks for connecting your bank statements. Your sales representative will be in touch shortly'
          : `${state.errorText ? state.errorText : displayErrors['ERROR']}`}
      </p>
      {!state.success && (
        <p>
          <a onClick={() => history.back()}>Try again</a>
        </p>
      )}
    </div>
  );
};

export default connect()(BankFeedsThanks);
